import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=afc63be4&"
import script from "./SidebarHeader.vue?vue&type=script&lang=ts&"
export * from "./SidebarHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports